import React from 'react';

const Welcome: React.FC = () => {
  return (
    <div>
      <h2>Welcome to Talethub Frontend!</h2>
      <p>This is your new React application.</p>
    </div>
  );
};

export default Welcome;
